import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var Odnoklassniki = function Odnoklassniki(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.829 8.666a1.127 1.127 0 011.41 1.76c-.053.041-1.047.828-2.707 1.166l2.505 2.483a1.127 1.127 0 01-1.593 1.595l-2.432-2.368-2.21 2.353a1.124 1.124 0 01-1.594.03 1.127 1.127 0 01-.029-1.595l2.379-2.485c-1.707-.33-2.743-1.137-2.796-1.18a1.127 1.127 0 011.41-1.759c.01.008 1.094.822 2.84.823 1.745 0 2.806-.815 2.816-.823zM8.067 0a4.146 4.146 0 110 8.292 4.146 4.146 0 010-8.292zm0 2.432a1.714 1.714 0 100 3.428 1.714 1.714 0 000-3.428z",
    fill: "currentColor"
  }));
};
export default Odnoklassniki;